import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Hero() {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            gsap.fromTo('.hero-text-part',
                { y: 80, opacity: 0 },
                { y: 0, opacity: 1, duration: 1.2, stagger: 0.15, ease: 'power3.out', delay: 0.2 }
            );
            gsap.fromTo('.hero-cta',
                { y: 40, opacity: 0 },
                { y: 0, opacity: 1, duration: 1, ease: 'power3.out', delay: 0.8 }
            );
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section
            ref={containerRef}
            className="relative w-full h-[100dvh] flex items-end pb-24 px-6 md:px-16 overflow-hidden bg-primary"
        >
            {/* Background Image matching imageMood: abstract modern architecture, lavender touches */}
            <div
                className="absolute inset-0 z-0 bg-cover bg-center"
                style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1541888087819-09415c833cd6?q=80&w=2070&auto=format&fit=crop")' }}
            />

            {/* Heavy primary-to-black gradient overlay */}
            <div className="absolute inset-0 z-0 bg-gradient-to-t from-primary via-primary/80 to-transparent mix-blend-multiply" />
            <div className="absolute inset-0 z-0 bg-gradient-to-b from-dark/40 to-transparent" />

            {/* Content */}
            <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-start pt-32">
                <h1 className="flex flex-col text-background">
                    <span className="hero-text-part font-heading font-bold text-3xl md:text-5xl lg:text-6xl tracking-tighter mb-2 md:mb-4">
                        Digital craftsmanship is the
                    </span>
                    <span className="hero-text-part font-drama italic text-6xl md:text-8xl lg:text-[10rem] leading-[0.85] text-accent">
                        New Standard.
                    </span>
                </h1>

                <div className="hero-text-part max-w-xl mt-8 mb-12">
                    <p className="text-lg md:text-xl text-background/80 font-subheading">
                        At Rossieau Creative Concepts, we build highly-performant, cinematic Flutter applications for iOS, Android, and Web.
                    </p>
                </div>

                <button className="hero-cta magnetic-btn bg-accent text-background px-8 py-4 rounded-full font-heading font-bold text-lg hover:bg-background hover:text-primary transition-colors flex items-center gap-2">
                    Book a consultation
                </button>
            </div>
        </section>
    );
}
